export default __webpack_public_path__ + "static/card-visa-classic@2x-8492b5d74457d78b7019b693caf06a04.png";